<p-dialog header="Status Detail" class="status-header" [(visible)]="displayStatusQueueDialog" [modal]="true"
    showEffect="fade" [width]="1120" (onHide)="hideStatusQueueDialog()" (onShow)="showStatusQueueDialog()"
    [autoAlign]="false">
    <div class="gridVerticalScroller">
        <sib-common-data-table [values]="values" [columns]="columns" (eEmitViewItemDetail)="viewItemDetail($event)"
            [loading]="loading"></sib-common-data-table>
    </div>
</p-dialog>